import { render, staticRenderFns } from "./TermAndCondition.vue?vue&type=template&id=ee63bece&scoped=true&"
import script from "./TermAndCondition.vue?vue&type=script&lang=js&"
export * from "./TermAndCondition.vue?vue&type=script&lang=js&"
import style0 from "./TermAndCondition.vue?vue&type=style&index=0&id=ee63bece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee63bece",
  null
  
)

export default component.exports